// extracted by mini-css-extract-plugin
export default {"body":"XgZtwG6KxvfPHAhlvgPP","header":"SRpteZSeaYZaQPa_Jn6_","seeReports":"VTCjJM0m0TmEnexrzikJ"};